

















import { Vue, Component, Prop } from "vue-property-decorator";

import ChatExportMessages from "./ChatExportMessages.vue";

import { ExportStage } from "../data/ChatExportDataLoader";

@Component({
    components: { ChatExportMessages }
})
export default class ChatExportStage extends Vue {
    @Prop({required: true}) stage: ExportStage;
    @Prop({required: true}) index: number;

    get position() {
        return this.stage.user?.position;
    }

    get company() {
        return this.stage.user?.company;
    }

    get name() {
        return this.stage.user?.firstName || this.stage.title.replace(/ .*/,'');
    }
}
